module.exports = __webpack_public_path__ + "assets/img/3_1393.e2fcaa55.jpg";